import { callbackify } from "util";
import { CalcRunId } from "./calc-run-id.model";

export class RunCalcJson {
    public openFlag: string;
    public runCtrlId: number;
    public token: string;
    public userName: string;
    public CalcRunModel: any;

    constructor() {
        this.openFlag = null;
        this.runCtrlId = null;
        this.token = null;
        this.userName = null;
        this.CalcRunModel = [];

    }
}
